// GET
export const GET_SOLUTIONS = 'GET_SOLUTIONS';
export const GET_SOLUTIONS_SUCCESS = 'GET_SOLUTIONS_SUCCESS';
export const GET_SOLUTIONS_FAIL = 'GET_SOLUTIONS_FAIL';

// ADD
export const ADD_SOLUTION = 'ADD_SOLUTION';
export const ADD_SOLUTION_SUCCESS = 'ADD_SOLUTION_SUCCESS';
export const ADD_SOLUTION_FAIL = 'ADD_SOLUTION_FAIL';

// UPDATE
export const UPDATE_SOLUTION = 'UPDATE_SOLUTION';
export const UPDATE_SOLUTION_SUCCESS = 'UPDATE_SOLUTION_SUCCESS';
export const UPDATE_SOLUTION_FAIL = 'UPDATE_SOLUTION_FAIL';

// DELETE
export const DELETE_SOLUTION = 'DELETE_SOLUTION';
export const DELETE_SOLUTION_SUCCESS = 'DELETE_SOLUTION_SUCCESS';
export const DELETE_SOLUTION_FAIL = 'DELETE_SOLUTION_FAIL';
